import { UserOutlined } from "@ant-design/icons";
import { Badge, Flex } from "antd";
import styled from "styled-components";

export const StyledMemberContainer = styled(Flex)`
    margin-top: 16px;
    padding: 16px;
    border-radius: 10px;
    flex-direction: column;
    && {
        background-color: ${(props) => props.theme.secondaryBackgroundColor};
    }
`;

export const StyledMemberBadge = styled(Badge)<{ $isWorking: boolean }>`
    .ant-badge-dot {
        top: 36px;
        left: 27px;
        height: 10px;
        width: 10px;

        background-color: ${({ $isWorking, theme }) =>
            $isWorking
                ? theme.successTypographyColor
                : theme.dangerTypographyColor};
    }
`;

export const StyledMemberLogo = styled(UserOutlined)`
    cursor: pointer;
    color: ${(props) => props.theme.primaryTypographyColor};
`;

export const StyledPhoneLink = styled.a`
    display: flex;
    align-items: center;
    gap: 8px;
`;
